/**
 * `escapeRegExp` parses a string for any characters that have special
 *  meaning in a regular expression and escapes them, for example:
 *  'foo-bar' becomes 'foo\\-bar'
 *  Escapes the following characters:
 *  - \ [ ] ( ) * + ? . , ^ | #
 */
export function escapeRegExp(query) {
    return query.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
}
//# sourceMappingURL=escapeRegExp.js.map